// extracted by mini-css-extract-plugin
export default {"private":"styles_private__5JN4a","customLabel":"styles_customLabel__tH2Zu"};